import toNumber from 'lodash/toNumber';

export default function (num, limit = 99) {
  const count = toNumber(num);

  if (count && count > limit) return limit;
  return count;
}
